exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeleteMessageModal-module__title___3zQ6v svg{color:#0827e9;font-size:22px}.DeleteMessageModal-module__content___16ynf{display:grid;gap:3rem}.DeleteMessageModal-module__content___16ynf .DeleteMessageModal-module__button-wrapper___1wjuB{display:grid;justify-content:end;gap:.75rem;grid-auto-flow:column}", ""]);

// exports
exports.locals = {
	"title": "DeleteMessageModal-module__title___3zQ6v",
	"content": "DeleteMessageModal-module__content___16ynf",
	"button-wrapper": "DeleteMessageModal-module__button-wrapper___1wjuB"
};